import { useMemo } from "react";
import { useClientConfig } from "@contexts/ClientConfigContext";

const TOOL_ORDER = [
  { key: "clarity", label: "Clarity", value: "Clarity" },
  { key: "fossid", label: "FossId", value: "FossId" },
  { key: "sbom", label: "SBOM", value: "SBOM" },
  { key: "clarityair", label: "ClarityAIR", value: "ClarityAIR" },
];

const convertScanToolsToOptions = (scanToolsValue, includeSBOM) => {
  if (!scanToolsValue) return [];

  const tools = scanToolsValue.split(",").filter(Boolean);

  return TOOL_ORDER
    .filter((item) => tools.includes(item.key))
    .filter((item) => (includeSBOM ? true : item.key !== "sbom"));
};

/**
 * Builds verification-type dropdown options from ClientConfigContext.
 * Does not call GET /client-config — ClientConfigProvider already loads that once.
 */
export const useVerificationTypeOptions = ({
  includeSBOM = false,
  scanTypeOptionsList = [],
}) => {
  const clientConfigContext = useClientConfig();
  const clientConfig = clientConfigContext?.clientConfig || {};

  const verificationTypeOptions = useMemo(() => {
    const scanTools = clientConfig?.scanTools?.codeValue;
    if (!scanTools) return [];
    return convertScanToolsToOptions(scanTools, includeSBOM);
  }, [clientConfig, includeSBOM]);

  const scanTypeOptions = useMemo(() => {
    if (!scanTypeOptionsList.length) return [];

    const hasSBOM = verificationTypeOptions.some((x) => x.key === "sbom");

    return scanTypeOptionsList.filter((opt) =>
      hasSBOM ? true : opt.value !== "SBOM"
    );
  }, [scanTypeOptionsList, verificationTypeOptions]);

  return {
    verificationTypeOptions,
    scanTypeOptions,
  };
};
